(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanaze-editorial-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-film')) {
    customElements.define('editorial-film', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.attempt = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.playButton = this.querySelector('.editorial-film__play');
        this.fullscreenButton = this.querySelector('.editorial-film__fullscreen');
        this.status = this.querySelector('[role="status"]');
        this.playButton.addEventListener('click', () => this.start(), options);
        this.fullscreenButton.addEventListener('click', () => this.start(true), options);
        // Prepare the short clip near the viewport, without slowing the first screen.
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.prepare();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      }

      prepare() {
        if (this.video) return;
        this.observer?.disconnect();
        this.append(this.querySelector('template').content.cloneNode(true));
        this.video = this.querySelector('video');
        const options = { signal: this.events.signal };
        this.video.addEventListener('playing', () => {
          this.video.inert = false;
          this.setAttribute('data-started', '');
          this.removeAttribute('aria-busy');
          this.status.textContent = '';
          this.playButton.disabled = false;
        }, options);
        this.video.addEventListener('ended', () => {
          if (document.fullscreenElement !== this.video && !this.video.webkitDisplayingFullscreen) this.restoreCover();
        }, options);
        this.video.addEventListener('fullscreenchange', () => {
          if (!document.fullscreenElement && this.video.ended) this.restoreCover();
        }, options);
        this.video.addEventListener('webkitendfullscreen', () => {
          if (this.video.ended) this.restoreCover();
        }, options);
        const loadError = () => {
          this.loadFailed = true;
          if (this.getAttribute('aria-busy') === 'true' || this.hasAttribute('data-started')) this.failed();
        };
        this.video.addEventListener('error', loadError, options);
        this.video.querySelector('source').addEventListener('error', loadError, options);
        this.video.preload = navigator.connection?.saveData ? 'metadata' : 'auto';
        this.video.load();
      }

      async start(fullscreen = false) {
        if (this.getAttribute('aria-busy') === 'true') return;
        this.prepare();
        const attempt = ++this.attempt;
        const retry = this.video.error || this.loadFailed;
        this.status.textContent = '';
        this.setAttribute('aria-busy', 'true');
        this.playButton.disabled = true;
        if (retry) {
          this.loadFailed = false;
          this.video.load();
        }
        if (this.video.ended) this.video.currentTime = 0;
        try {
          const playback = this.video.play();
          if (fullscreen) {
            if (this.video.requestFullscreen) this.video.requestFullscreen().catch(() => {});
          }
          await playback;
          if (!this.isConnected || attempt !== this.attempt) return;
          if (fullscreen && !this.video.requestFullscreen && this.video.webkitEnterFullscreen) {
            try { this.video.webkitEnterFullscreen(); } catch { /* Native controls remain available. */ }
          }
          this.video.focus({ preventScroll: true });
        } catch (error) {
          if (!this.isConnected || attempt !== this.attempt) return;
          if (error.name !== 'AbortError') this.failed();
        } finally {
          if (attempt === this.attempt) {
            this.removeAttribute('aria-busy');
            this.playButton.disabled = false;
          }
        }
      }

      restoreCover() {
        const wasFocused = document.activeElement === this.video;
        this.removeAttribute('data-started');
        this.video.inert = true;
        if (wasFocused) this.playButton.focus({ preventScroll: true });
      }

      failed() {
        this.restoreCover();
        this.removeAttribute('aria-busy');
        this.playButton.disabled = false;
        this.status.textContent = this.dataset.error;
      }

      disconnectedCallback() {
        this.attempt++;
        this.events?.abort();
        this.events = null;
        this.loadFailed = false;
        this.observer?.disconnect();
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          this.video.load();
          this.video.remove();
          this.video = null;
        }
        this.removeAttribute('data-started');
        this.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanaze-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-home-search')) {
    customElements.define('editorial-home-search', class extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.editorial-cover__search-toggle');
        this.searchForm = this.querySelector('form');
        this.searchInput = this.querySelector('input[type="search"]');
        if (!this.toggleButton || !this.searchForm) return;
        this.toggleButton.addEventListener('click', this.toggleSearch);
        this.addEventListener('keydown', this.closeOnEscape);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.toggleSearch);
        this.removeEventListener('keydown', this.closeOnEscape);
      }

      toggleSearch = () => {
        const expanded = this.searchForm.hidden;
        this.searchForm.hidden = !expanded;
        this.toggleButton.setAttribute('aria-expanded', String(expanded));
        if (expanded) this.searchInput.focus();
      };

      closeOnEscape = (event) => {
        if (event.key !== 'Escape' || this.searchForm.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        this.toggleSearch();
        this.toggleButton.focus();
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
